<header>
  <img src="assets/imgs/logo-evento.png" alt="Logo evento">
  <h1><span i18n="@@web-inscripciones.inscripciones">Inscripciones {{event_name}} {{event_year}}</span></h1>
  <img src="assets/imgs/logo-collegi.png" alt="El Col·legi">
</header>

<section class="page-body">
  @let status = resultado_pago();
  
  @if (status === STATUS_EP) {
    <div class="msg msg-en-proceso">
      <mat-icon>report_problem</mat-icon>
      <div class="texto">
        <h4 class="error-head">
          <span>Confirmando incripción</span>
        </h4>
        <p>Su inscripción está siendo confirmada</p>
        <p>Por favor, espere unos momentos</p>
        <p class="spinner">
          <mat-spinner diameter="24" style="text-align: center"></mat-spinner>
        </p>
      </div>
    </div>
  } @else if (status === STATUS_KO) {
    <div class="msg msg-error">
      <mat-icon>report_problem</mat-icon>
      <div class="texto">
        <h4 class="error-head">
          <span>Error confirmando incripción</span>
        </h4>
        <p>Su pago se ha realizado correctamente pero <strong>su inscripción no ha podido ser confirmada</strong> debido a errores técnicos.</p>
        <p>Por favor, póngase en contacto con el Col·legi de Mediadors d'Assegurances de Barcelona</p>
      </div>
      @if (server_error()) {
        <div class="msg-explain-error">
          {{server_error()}}
        </div>
      }
    </div>
  } @else if (status === STATUS_OK) {
    <div class="msg">
      <mat-icon>thumb_up_off_alt</mat-icon>
      <div class="texto">
        <p>Sr/Sra {{inscripcion_data().apellido1}}:</p>
        <p>
          Te confirmamos que te has inscrito correctamente a la 'Semana Mundial 2026' del Col·legi de
          Mediadors d'Assegurances de Barcelona, que tendrá lugar el próximo 
          28 de Septiembre de 2026 a las 17:00 en el Auditori de Barcelona, Carrer de Lepant, 150, 08013 Barcelona.
        </p>
        <p>
          Recibirás un correo electrónico con la acreditación para acceder a la Semana Mundial 2026,
          la cual es imprescindible que la presentes en formato, digital o impresa, a tu llegada al
          recinto para poder acceder al Auditori de Barcelona.<br />
          Encontrarás toda la información de la 'Semana Mundial 2026' en <a href="https://semanamundial.com/" target="_blank">http://semanamundial.com/</a><br />
          ¡Te esperamos!
        </p>
        @if (lista_invitados().length) {
          <div class="">
            <p>
              Del mismo modo, su acompañante también recibirá en el
              email de registro con su respectiva acreditación.
            </p>
          </div>
        }
        @if (inscripcion_data().importe_factura) {
          <div class="">
            <p>
              Si desea una factura por el pago realizado, por favor pulse en el botón de más abajo
            </p>
          </div>
        }
        <p>Muchas gracias, te esperamos el próximo 28 de septiembre!<br />Col·legi de Mediadors d'Assegurances - Barcelona</p>
      </div>
    </div>
  }
</section>

<footer>
  <nav class="btns-nav">
    <button mat-raised-button color="primary" routerLink="/inscript">
      <span i18n="@@web-inscripciones.realizar-otra-inscripcion">Realizar otra inscripción</span>
    </button>
    @if (resultado_pago() === STATUS_OK && inscripcion_data().importe_factura) {
      <button mat-raised-button color="primary" (click)="openWindowFacturas()">
        <span i18n="@@web-inscripciones.solicitar-factura">Solicitar factura</span>
      </button>
    }
  </nav>
</footer>
